import './PopoverMenuButton.scss';

import { ButtonType } from 'antd/es/button';
import classNames from 'classnames';
import { getDirectParent } from '@lib/popups';
import { MenuProps } from 'antd/lib';
import { TooltipPlacement } from 'antd/es/tooltip';

import { Button, Menu, Popover } from 'antd';
import React, { PropsWithChildren } from 'react';

export type PopoverMenuItems = Required<MenuProps>['items'];

export interface PopoverMenuButtonProps {
	getPopupContainer?: (element: HTMLElement) => HTMLElement;
	icon?: React.ReactNode;
	id: string;
	menuItems: PopoverMenuItems;
	onClick?: React.MouseEventHandler<HTMLElement>;
	onOpenChange?: (visibility: boolean) => void;
	overlayClassName?: string;
	placement?: TooltipPlacement;
	type?: ButtonType;
}

const defaultOverlayClassName = 'popover-menu-button-overlay';

export const PopoverMenuButton: React.FC<PropsWithChildren<PopoverMenuButtonProps>> = ({
	children,
	getPopupContainer = getDirectParent,
	icon,
	id,
	menuItems,
	onClick,
	onOpenChange,
	overlayClassName,
	placement = 'bottomRight',
	type = 'default'
}) =>
	<Popover
		classNames={ { root: classNames(defaultOverlayClassName, overlayClassName) } }
		content={ <Menu items={ menuItems } /> }
		getPopupContainer={ getPopupContainer }
		onOpenChange={ onOpenChange }
		placement={ placement }
		trigger='click'>
		<Button
			icon={ icon }
			id={ id }
			onClick={ onClick }
			type={ type }>
			{ children }
		</Button>
	</Popover>;

